// extracted by mini-css-extract-plugin
module.exports = {"container":"verify_container__1YzwW","logo":"verify_logo__5MTI4"};